import { color } from "@isale/design-tokens";
import { cn } from "@/lib/utils";

export function Logo({
  className,
  variant = "color",
  withWordmark = true,
  size = 28,
}: {
  className?: string;
  variant?: "color" | "mono" | "ink";
  withWordmark?: boolean;
  /** Pixel size of the mark. Wordmark scales with font-size separately. */
  size?: number;
}) {
  // Brand mark gradient — sourced from the canonical palette (matches mobile
  // Logo). White stops for the mono variant are intrinsic to the brand asset.
  const fillFrom = variant === "mono" ? "#FFFFFF" : color.indigo[400];
  const fillTo = variant === "mono" ? "#FFFFFF" : color.indigo[600];
  const textColor =
    variant === "mono"
      ? "text-white"
      : variant === "ink"
        ? "text-fg"
        : "text-primary-strong";
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden>
        <defs>
          <linearGradient id="logoG" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={fillFrom} />
            <stop offset="100%" stopColor={fillTo} />
          </linearGradient>
        </defs>
        <rect width="32" height="32" rx="7" fill="url(#logoG)" />
        <path
          d="M16 8.5l1.8 4.4 4.7.7-3.4 3.1.9 4.6L16 18.9l-4 2.4.9-4.6-3.4-3.1 4.7-.7L16 8.5z"
          fill="#FFFFFF"
        />
      </svg>
      {withWordmark && (
        <span className={cn("text-lg font-extrabold tracking-tight", textColor)}>
          iSale
        </span>
      )}
    </span>
  );
}
